import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';

import { ResourcesRoutingModule } from './resources-routing.module';
import { ResourcesComponent } from './resources/resources.component';
import { PipeModule } from 'app/shared/pipes/pipe.module';


@NgModule({
  declarations: [
    ResourcesComponent
  ],
  imports: [
    CommonModule,
    ResourcesRoutingModule,
    PipeModule,

  ]
})
export class ResourcesModule { }
